import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=cc69c802&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=cc69c802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc69c802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc69c802')) {
      api.createRecord('cc69c802', component.options)
    } else {
      api.reload('cc69c802', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=cc69c802&scoped=true&", function () {
      api.rerender('cc69c802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SlpSuFoPezTE/JS/comp/GuestBoxKids.vue"
export default component.exports